/*
 * Copyright (c) 2023. RoZetta Technology Pty Ltd. All rights reserved.
 */

import {
	Grid,
	Stack,
	Button,
	Typography
} from "@mui/material";
import * as React from "react";
import { Link } from "react-router-dom";
import {useMsal} from "@azure/msal-react";
import {landingPageText} from "../assets/texts/pageTextContent";

const styles = {
	button: {
		color: "#000000"
	},
};

export default function MarketCapHome () {

	const {instance} = useMsal();

	const initializeSignIn = () => {
		instance.loginRedirect();
	};

	return <>
		<Grid
			container
			spacing={10}
			display={"flex"}
			justifyContent="center"
			sx={{ pt: "10%" }}>
			<Grid item xs={4} >
				<Typography
					variant={"h2"}
					component="div"
					>
					{landingPageText}
				</Typography>
			</Grid>
			<Grid item xs={3}>
				<Stack spacing={10} sx={{ pt: 5}}>
					<Button style={styles.button} variant='outlined' onClick={initializeSignIn}>Sign-in</Button>
					<Button style={styles.button} variant='outlined' component={Link} to={"/request-access"}>Request Access</Button>
				</Stack>
			</Grid>
		</Grid>
	</>;
}
